import { CONTENT_ALIGNMENT } from '@pperform/pp-constants/widgetConfigs';
import PpProgressIndicatorForward from '@pperform/pp-react-components/PpProgressIndicatorForward';
import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { constructForwardProgressIndicatorTheme } from 'utils/progressIndicator.utils';
import { Container } from './BlankProgressIndicator.styles';

export const BlankProgressIndicator = () => {
  const { t } = useTranslation();
  const configs = usePTPConfigContext();
  const {
    trackingDetailsBox: { timelineAlignment },
  } = configs;
  const progressItemThemes = constructForwardProgressIndicatorTheme(configs);

  return (
    <Container>
      <PpProgressIndicatorForward
        translation={t}
        progressItemThemes={progressItemThemes}
        alignEdgeItems={timelineAlignment === CONTENT_ALIGNMENT.LEFT}
      />
    </Container>
  );
};
